import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Editorcontainer, EditorcontainerTools, EditorHeader, EditorWrapper, LeftPanel, LeftPanelContainer, LeftPanelCard, PanelBody, PanelHeader, PanelHeaderTitle, LayersTree, ToolBar, ToolBarInner, Tools, SingleTool, ToolIcon, ToolDropDown, ToolMenuItem, LeftPanelCardHead, LeftPanelCardBody, PanelSearch, LeftPanelCardFooter, EditorMap, HeaderMenuItem, HeaderMenuItemDropdown, EditorHeaderSection, EditorTools, EditorHeaderItem, HeaderMenuItemDropdownAction, EditorContent, EditorToolArea, EditorMapController, EditorMapControllerInner, FloatingPanel, FloorDropdown, } from './editor.style';
import { Button as AntdButton, Divider, Dropdown, Flex, Form, Tooltip, Checkbox, message, Spin, Modal } from 'antd';
import Icon from '../../components/common/Icon';
import AlphabetList from '../../components/common/AlphabetList';
import Map from 'ol/Map';
import View from 'ol/View';
import { fromLonLat, toLonLat } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Style, Fill, Stroke, Text, Icon as OlIcon } from 'ol/style';
import 'ol/ol.css';
import becoLogo from '../../assets/images/becomap.png';
import { Draw as DrawInteraction, Modify } from 'ol/interaction';
import { Select as SelectInteraction } from 'ol/interaction';
{ /* OpenLayers select interaction for feature selection */ }
import { LineString, MultiPoint, Circle as OlCircle, Polygon } from 'ol/geom';
import { createBox } from 'ol/interaction/Draw';
{ /* @ts-ignore */ }
import SplitterInteraction from 'ol-ext/interaction/Splitter';
import { Circle as CircleStyle } from 'ol/style';
import { Snap } from 'ol/interaction';
{ /* @ts-ignore */ }
import SnapGuides from 'ol-ext/interaction/SnapGuides';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEvents, fetchLocationCategories, fetchLocationSiblings, fetchLocationStates, fetchLocationZones, fetchSiteLayers, getCategoriesIconAction, getConnectionsAction, } from '../../store/EditoreSlice';
import { createSiteLayers, getFloorShapeAction } from '../../store/EditoreSlice';
{ /* @ts-ignore */ }
import { Deck } from '@deck.gl/core';
{ /* @ts-ignore */ }
import { BitmapLayer } from '@deck.gl/layers';
import LayerLayer from 'ol/layer/Layer';
import { getBuildingAction, getFloorAction } from '../../store/floorSlice';
import { convertToRadian } from '../../shared/utils';
import useSocket from '../../shared/socket';
import { Collection } from 'ol';
import pako from 'pako';
import { LayerManager } from './components/LayerManager';
import ShapePropertiesPanel from './components/Properties';
import { _deleteConnection } from '../../shared/httpservice/apis/connections';
import { applyStyle } from 'ol-mapbox-style';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import Button from '../../components/common/Button';
import LocationPanel from './panel/locationPanel';
import CategoryPanel from './panel/categoryPanel';
import ConnectionsPanel from './panel/connectionsPanel';
import LocationListPanel from './panel/locationListPanel';
import ThreeDObjectListPanel from './panel/3dObject/ListPanel';
import ThreeDObjectFormPanel from './panel/3dObject/FormPanel';
import MapThreeDObjectFormPanel from './panel/Map3dObject/FormPanel';
import MappedThreeDObjectListPanel from './panel/Map3dObject/ListPanel';
import { onPropertiesChange, saveRouteData, saveShape, findTitle, updatePointsToVertices, removeDuplicateFeatures, removeDuplicatesFromSource, getGeoJson, createGeoJSONFromFeature, handlePolygonDrawEnd, handleCircleDrawEnd, handleLineStringDrawEnd, hideFeatures, unhideFeatures, deleteSelectedFeatures, buildSite, getFloorDataByKey, getSelectedTitles } from './utils/editorUtils';
import { resetAllStates, clearPersist } from '../../store';
import EventPanel from './panel/eventPanel';
import EventListPanel from './panel/eventListPanel';
import { getMap3DObjectPropertiesAction, getMap3DObjectsAction } from '../../store/mapObjectSlice';
import { getSupportedLanguagesAction, getSiteLanguagesAction } from '../../store/mutliLanguageSlice';
import { fetchNodesBySiteAndFloor } from '../../store/nodesSlice';
import useQueryParams from '../../hooks/useQueryParams';
import FloorViewportListPanel from './panel/FloorViewport/ListPanel';
import ViewPortFormPanel from './panel/FloorViewport/FormPanel';
import LanguageListPanel from './panel/languages/LIstPanel';
import AddLanguageForm from './panel/languages/AddLanguageForm';
import LanguageConfigForm from './panel/languages/LanguageConfigForm';
import ProgressModal from './components/progressModal';
import BuildModal from './components/buildModal';
import { useNavigate } from 'react-router-dom';
const Editor = () => {
    const navigate = useNavigate();
    const items = [
        {
            key: 'mapping',
            label: 'Mapping',
            icon: _jsx(Icon, { icon: "map-01", size: 16 }),
            onClick: () => {
                setSideBar('mapping');
            },
        },
        {
            key: 'connections',
            label: 'Connections',
            icon: _jsx(Icon, { icon: "dataflow-03", size: 16 }),
            onClick: () => {
                setSideBar('connections');
            },
        },
        {
            key: 'locations',
            label: 'Locations',
            icon: _jsx(Icon, { icon: "marker-pin-06", size: 16 }),
            onClick: () => {
                setSideBar('locations');
            },
        },
        {
            key: 'categories',
            label: 'Categories',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('categories');
            },
        },
        {
            key: 'events',
            label: 'Events',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('events');
            },
        },
        {
            key: '3dObject',
            label: '3D Objects',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('3dObject');
            },
        },
        {
            key: 'mapped3dObjects',
            label: 'Assigned 3D Objects',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('mapped3dObjects');
            },
        },
        {
            key: 'floor_viewport',
            label: 'Floor Viewport',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('floor_viewport');
            },
        },
        {
            key: 'languages',
            label: 'Languages',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                setSideBar('languages');
            },
        },
        {
            key: 'api-key',
            label: 'API Key',
            icon: _jsx(Icon, { icon: "marker-pin-01", size: 16 }),
            onClick: () => {
                navigate('/api-key');
            },
        },
        {
            key: 'feedbacks',
            label: 'Feedbacks',
            icon: _jsx(Icon, { icon: "message-square-01", size: 16 }),
            onClick: () => {
                navigate('/feedbacks');
            },
        },
        {
            key: 'visitors',
            label: 'Visitors',
            icon: _jsx(Icon, { icon: "users-01", size: 16 }),
            onClick: () => {
                navigate('/visitors');
            },
        },
    ];
    { /* ==================== STATE VARIABLES ==================== */ }
    const [selectNode, setSelectNode] = useState(false);
    const [selectedSidebar, setSeletedSidebar] = useState('mapping');
    const [editLocation, setEditLocation] = useState(null);
    const [editFloorViewport, setEditFloorViewport] = useState(null);
    const [editCategory, setEditCategory] = useState(null);
    const [editMappedThreedObject, setEditMappedThreedObject] = useState(null);
    const [editEvent, setEditEvent] = useState(null);
    const [editConnections, setEditConnection] = useState(null);
    const [map, setMap] = useState(null);
    const [activeTool, setActiveTool] = useState(null);
    const [lastUsedShape, setLastUsedShape] = useState('custom');
    const [locationNodes, setLocationNodes] = useState([]);
    const [connectionNodes, setConnectionNodes] = useState([]);
    const [buildingTree, setBuildingTree] = useState([]);
    const [searchKey, setSearchKey] = useState();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [floorName, setFloorName] = useState('');
    const [selectedNodeIndex, setSelectedNodeIndex] = useState(null);
    const [mapData, setMapData] = useState([]);
    const [routeCollection, setRouteCollection] = useState({});
    const [selectedCat, setSelectedCat] = useState([]);
    const [selectedConnections, setSelectedConnections] = useState([]);
    const [floorLayerData, setFloorLayerData] = useState([]);
    const [socketIsConnected, setSocketIsConnected] = useState(true);
    const [socketMessage, setSocketMessage] = useState('Connection Lost.Trying to reconnect....');
    const [rotation, setRotation] = useState(0);
    const [languageConfigData, setLanguageConfigData] = useState(null);
    const [selectedDropdownItem, setSelectedDropdownItem] = useState(items[0]);
    const [routeFlag, setRouteFlag] = useState(false);
    const [selectedLayerData, setSelectedLayerData] = useState();
    const [mapObjectPropertyNodes, setMapObjectPropertyNodes] = useState([]);
    const [nodesData, setNodesData] = useState();
    const [branches, setBranches] = useState([]);
    const [layerAdded, setLayerAdded] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState();
    const [selectedFeatures, setSelectedFeatures] = useState(null);
    const [selectedConnectionNode, setSelectedConnectionNode] = useState(null);
    const [previousStyle, setPreviousStyle] = useState(null);
    const [routeEndPointStyles, setRouteEndPointStyles] = useState({});
    const [buildFlag, setBuildFlag] = useState(false);
    { /* ==================== COMPONENT REFS ==================== */ }
    const activeFormRef = useRef(null);
    const wallLayerRef = useRef(null);
    const polygonLayerRef = useRef(null);
    const routeLayerRef = useRef(null);
    const pointLayerRef = useRef(null);
    const mapRef = useRef(null);
    const deckRef = useRef(null);
    const idRef = useRef(null);
    const layerRef = useRef(null);
    const originalStylesRef = useRef([]);
    const [formCategory] = Form.useForm();
    const [formConnection] = Form.useForm();
    const [mapObjectForm] = Form.useForm();
    { /* ==================== REDUX SELECTORS ==================== */ }
    const locationSiblings = useSelector((state) => state?.editor?.locationSiblings.response);
    const locationCategories = useSelector((state) => state?.editor?.locationCategories.response);
    const siteLayers = useSelector((state) => state?.editor?.siteLayers);
    const floorShapes = useSelector((state) => state?.editor?.floorShapes?.response);
    const mapObjectProperties = useSelector((state) => state?.mapObject?.getMapObjectProperties?.response?.content);
    const buildingDataLoading = useSelector((state) => state?.floors?.buildings?.loading);
    const floorDataLoading = useSelector((state) => state?.floors?.getFloor?.loading);
    const connections = useSelector((state) => state?.editor?.connections?.response);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const socket = useSocket(selectedKeys?.join('') || null, setSocketIsConnected, setSocketMessage);
    const siteLat = useSelector((state) => state?.site?.checkSite?.response?.data?.latitude);
    const siteLng = useSelector((state) => state?.site?.checkSite?.response?.data?.longitude);
    const userDetails = useSelector((state) => state?.auth?.userDetails?.response?.data);
    const nodesDataFromStore = useSelector((state) => state?.nodes?.response?.content);
    { /* Redux action dispatcher instance */ }
    const dispatch = useDispatch();
    { /* Custom hook for managing URL query parameters */ }
    const { setQueryParam, getQueryParam } = useQueryParams();
    const itemShapes = [
        {
            key: '2',
            label: (_jsxs(ToolMenuItem, { children: [lastUsedShape === 'circle' && _jsx(Icon, { icon: "check", size: 14 }), _jsxs("span", { onClick: () => {
                            if (selectedBranch === 'Route Layer' || selectedBranch === 'Outer Wall') {
                                message.warning('Please select a layer other than Route Layer or Outer Wall to draw or create a new layer');
                            }
                            else {
                                selectShape('circle');
                            }
                        }, children: [_jsx(Icon, { icon: "circle", size: 16 }), " Circle"] })] })),
            extra: 'o',
        },
        {
            key: '3',
            label: (_jsxs(ToolMenuItem, { children: [lastUsedShape === 'custom' && _jsx(Icon, { icon: "check", size: 14 }), _jsxs("span", { onClick: () => {
                            if (selectedBranch === 'Route Layer' || selectedBranch === 'Outer Wall') {
                                message.warning('Please select a layer other than Route Layer or Outer Wall to draw or create a new layer');
                            }
                            else {
                                selectShape('custom');
                            }
                        }, children: [_jsx(Icon, { icon: "hexagon-02", size: 16 }), " Custom"] })] })),
            extra: 'l',
        },
    ];
    const profileItems = [
        {
            key: '1',
            label: userDetails?.email || 'User',
            icon: _jsx(Icon, { icon: "user-01", size: 16 }),
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: '4',
            label: 'Sign out',
            onClick: () => {
                clearPersist();
                resetAllStates(dispatch);
                window.location.href = SITE_URL;
            },
            icon: _jsx(Icon, { icon: "log-out-02", size: 16 }),
        },
    ];
    { /* ==================== SIDE EFFECTS (useEffect hooks) ==================== */ }
    { /* Initialize sidebar panel from URL parameters and persist on refresh */ }
    useEffect(() => {
        const panel = getQueryParam('panel');
        if (panel) {
            setSeletedSidebar(panel);
            setSelectedDropdownItem(items?.find((item) => item?.key === panel));
        }
    }, []);
    { /* Initialize selected floor from URL parameters and set default if none exists */ }
    useEffect(() => {
        const floorId = getQueryParam('floor');
        if (buildingTree?.length) {
            if (!floorId) {
                const firstFloor = buildingTree[0]?.children[0];
                setQueryParam('floor', firstFloor?.key);
            }
        }
    }, [buildingTree]);
    { /* Update map data when floor selection changes - selectedKeys contains floor ID */ }
    useEffect(() => {
        if (selectedKeys) {
            const mapData = getFloorDataByKey(buildingTree, selectedKeys?.join());
            setMapData(mapData);
        }
    }, [selectedKeys]);
    { /* Initialize and configure DeckGL + OpenLayers map integration */ }
    useEffect(() => {
        if (!mapData && !mapData?.geoReferences && !mapData?.geoReferences?.length)
            return;
        if (!mapRef.current) {
            return;
        }
        document.body.style.cursor = 'pointer';
        { /* Clean up previous DeckGL instance to prevent memory leaks */ }
        if (deckRef.current) {
            deckRef.current.finalize();
            deckRef.current = null;
        }
        const geoReference = mapData?.geoReferences;
        const controlArray = geoReference?.map((item) => [item?.control?.x, item?.control?.y]);
        controlArray?.push([geoReference[0].control.x, geoReference[0].control.y]);
        const baseFloorData = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: [controlArray],
                    },
                },
            ],
        };
        const layers = [
            new BitmapLayer({
                id: 'bitmap-layer',
                bounds: baseFloorData?.features[0]?.geometry?.coordinates[0],
                image: `${mapData?.imageUrl}`,
                opacity: 0.1,
            }),
        ];
        const INITIAL_VIEW_STATE = {
            longitude: siteLng ? siteLng : 0,
            latitude: siteLat ? siteLat : 0,
            zoom: 19,
            bearing: 0,
            pitch: 0,
        };
        { /* Initialize new DeckGL instance for image rendering */ }
        deckRef.current = new Deck({
            initialViewState: INITIAL_VIEW_STATE,
            parent: mapRef.current,
            controller: true,
            style: {
                pointerEvents: 'none',
                'z-index': 1,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
            },
            layers, // DeckGL layers for image rendering
        });
        { /* Initialize OpenLayers map for 2D vector operations */ }
        const initialMap = new Map({
            target: mapRef.current,
            // Base tile layers disabled - using DeckGL for rendering
            // layers: [
            //   new TileLayer({
            //     source: new OSM({
            //     }),
            //   }),
            // ],
            view: new View({
                center: siteLat && siteLng ? fromLonLat([siteLng, siteLat]) : [0, 0],
                zoom: 19,
                rotation: rotation ? convertToRadian(Number(rotation)) : 0,
            }),
        });
        fetch('https://beco-lightning-backend.s3.ap-southeast-1.amazonaws.com/styles/style.json')
            .then((response) => response.json())
            .then((styleJson) => {
            styleJson.layers = styleJson.layers.map((layer) => ({
                ...layer,
                layout: { ...layer.layout, visibility: 'none' },
            }));
            const vectorTileLayer = new VectorTileLayer({
                source: new VectorTileSource({
                    format: new MVT(),
                    url: styleJson.sources.openmaptiles.url, // Vector tile server URL
                }),
            });
            // Apply the style.json to the vector tile layer
            applyStyle(vectorTileLayer, styleJson).then(() => {
                initialMap.addLayer(vectorTileLayer);
            });
        })
            .catch((error) => {
            //error
        });
        { /* Create bridge layer to synchronize OpenLayers view with DeckGL rendering */ }
        const deckLayer = new LayerLayer({
            render: function ({ size, viewState }) {
                const [width, height] = size;
                const [longitude, latitude] = toLonLat(viewState.center);
                const zoom = viewState.zoom - 1;
                const bearing = (-viewState.rotation * 180) / Math.PI;
                if (deckRef.current) {
                    const deckViewState = {
                        bearing,
                        longitude,
                        latitude,
                        zoom,
                    };
                    deckRef.current.setProps({ width, height, viewState: deckViewState });
                    deckRef.current.redraw();
                }
                return document.createElement('div'); // Return a DOM element as required by RenderFunction
            },
        });
        { /* Integrate DeckGL layer with OpenLayers map */ }
        initialMap.addLayer(deckLayer);
        setMap(initialMap);
        { /* Cleanup function to prevent memory leaks */ }
        return () => {
            if (initialMap) {
                initialMap.setTarget(undefined);
            }
            if (deckRef.current) {
                deckRef.current.finalize(); // Clean up DeckGL instance on component unmount
            }
        };
    }, [buildingDataLoading, floorDataLoading, mapData, rotation]);
    // Create cached styles to avoid recreating them on every render
    const cachedStyles = useMemo(() => {
        // Inner Wall Styles
        const innerWallMainStyle = new Style({
            stroke: new Stroke({
                color: '#8B5CF6',
                width: 5,
                lineCap: 'round',
                lineJoin: 'round',
                lineDash: [12, 6],
            }),
        });
        const innerWallShadowStyle = new Style({
            stroke: new Stroke({
                color: 'rgba(139, 92, 246, 0.2)',
                width: 8,
                lineCap: 'round',
                lineJoin: 'round',
            }),
        });
        const innerWallVertexStyle = new Style({
            image: new CircleStyle({
                radius: 3,
                fill: new Fill({ color: '#7C3AED' }),
                stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
            }),
        });
        // Fallback polygon styles
        const fallbackPolygonStyle = new Style({
            stroke: new Stroke({
                color: '#059669',
                width: 4,
                lineCap: 'round',
                lineJoin: 'round',
            }),
            fill: new Fill({
                color: 'rgba(5, 150, 105, 0.08)',
            }),
        });
        const fallbackVertexStyle = new Style({
            image: new CircleStyle({
                radius: 3,
                fill: new Fill({ color: '#047857' }),
                stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
            }),
        });
        return {
            innerWall: {
                main: innerWallMainStyle,
                shadow: innerWallShadowStyle,
                vertex: innerWallVertexStyle,
            },
            fallback: {
                polygon: fallbackPolygonStyle,
                vertex: fallbackVertexStyle,
            },
        };
    }, []);
    // Create cached polygon styles
    const polygonCachedStyles = useMemo(() => {
        const rectangleStyle = new Style({
            stroke: new Stroke({
                color: '#D946EF',
                width: 3,
                lineDash: [8, 4],
            }),
            fill: new Fill({
                color: 'rgba(217, 70, 239, 0.15)',
            }),
        });
        const circleStyle = new Style({
            stroke: new Stroke({
                color: '#E11D48',
                width: 4,
            }),
            fill: new Fill({
                color: 'rgba(225, 29, 72, 0.2)',
            }),
        });
        const polygonMainStyle = new Style({
            stroke: new Stroke({
                color: '#06B6D4',
                width: 5,
                lineCap: 'round',
                lineJoin: 'round',
            }),
            fill: new Fill({
                color: 'rgba(6, 182, 212, 0.12)',
            }),
        });
        const polygonInnerStyle = new Style({
            stroke: new Stroke({
                color: '#0891B2',
                width: 2,
                lineCap: 'round',
                lineJoin: 'round',
            }),
        });
        const wallMainStyle = new Style({
            stroke: new Stroke({
                color: '#7C3AED',
                width: 6,
                lineCap: 'round',
                lineJoin: 'round',
            }),
            fill: new Fill({
                color: 'rgba(124, 58, 237, 0.08)',
            }),
        });
        const wallShadowStyle = new Style({
            stroke: new Stroke({
                color: 'rgba(124, 58, 237, 0.3)',
                width: 5,
                lineCap: 'round',
                lineJoin: 'round',
            }),
        });
        const defaultStyle = new Style({
            stroke: new Stroke({
                color: '#F59E0B',
                width: 4,
                lineCap: 'round',
                lineJoin: 'round',
            }),
            fill: new Fill({
                color: 'rgba(245, 158, 11, 0.1)',
            }),
        });
        // Vertex styles
        const vertexStyles = {
            rectangle: new Style({
                image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: '#D946EF' }),
                    stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
                }),
            }),
            circle: new Style({
                image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: '#E11D48' }),
                    stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
                }),
            }),
            polygon: new Style({
                image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: '#06B6D4' }),
                    stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
                }),
            }),
            wall: new Style({
                image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: '#7C3AED' }),
                    stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
                }),
            }),
            default: new Style({
                image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: '#6B7280' }),
                    stroke: new Stroke({ color: '#FFFFFF', width: 1 }),
                }),
            }),
        };
        return {
            rectangle: rectangleStyle,
            circle: circleStyle,
            polygon: { main: polygonMainStyle, inner: polygonInnerStyle },
            wall: { main: wallMainStyle, shadow: wallShadowStyle },
            default: defaultStyle,
            vertices: vertexStyles,
        };
    }, []);
    //Create cached route styles
    const routeCachedStyles = useMemo(() => {
        const routeMainStyle = new Style({
            stroke: new Stroke({
                color: '#10B981',
                width: 6,
                lineCap: 'round',
                lineJoin: 'round',
            }),
        });
        const routeShadowStyle = new Style({
            stroke: new Stroke({
                color: 'rgba(16, 185, 129, 0.3)',
                width: 10,
                lineCap: 'round',
                lineJoin: 'round',
            }),
        });
        const routeVertexStyle = new Style({
            image: new CircleStyle({
                radius: 8,
                fill: new Fill({ color: '#059669' }),
                stroke: new Stroke({ color: '#FFFFFF', width: 3 }),
            }),
        });
        return {
            main: routeMainStyle,
            shadow: routeShadowStyle,
            vertex: routeVertexStyle,
        };
    }, []);
    //Create cached point styles
    const pointCachedStyles = useMemo(() => {
        const createPointStyle = (fillColor, radius, strokeColor = '#FFFFFF', strokeWidth = 2) => new Style({
            image: new CircleStyle({
                radius,
                fill: new Fill({ color: fillColor }),
                stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
            }),
        });
        return {
            default: createPointStyle('#10B981', 5),
            location: createPointStyle('#F59E0B', 6),
            connection: createPointStyle('#EF4444', 5),
            object: createPointStyle('#3B82F6', 5),
            highlighted: createPointStyle('#FBBF24', 6, '#F59E0B', 2),
        };
    }, []);
    { /* Initialize vector layers for drawing and editing geometric features */ }
    useEffect(() => {
        if (!map)
            return;
        // Inner Wall Layer - Optimized with cached styles
        wallLayerRef.current = new VectorLayer({
            source: new VectorSource(),
            style: (feature) => {
                const geometry = feature?.getGeometry();
                const type = feature?.get('type');
                const styles = [];
                if (type === 'INNER_WALL' || geometry?.getType() === 'LineString') {
                    // Use cached styles
                    styles.push(cachedStyles.innerWall.shadow, cachedStyles.innerWall.main);
                    //add vertex points if needed
                    if (geometry?.getType() === 'LineString' && !feature.get('isDrawing')) {
                        const coordinates = geometry.getCoordinates();
                        const points = new MultiPoint(coordinates);
                        const vertexStyle = cachedStyles.innerWall.vertex.clone();
                        vertexStyle.setGeometry(points);
                        styles.push(vertexStyle);
                    }
                }
                else {
                    // Use cached fallback styles
                    styles.push(cachedStyles.fallback.polygon);
                    if (geometry?.getType() === 'Polygon' && !feature.get('isDrawing')) {
                        const coordinates = geometry.getCoordinates()[0];
                        const points = new MultiPoint(coordinates);
                        const vertexStyle = cachedStyles.fallback.vertex.clone();
                        vertexStyle.setGeometry(points);
                        styles.push(vertexStyle);
                    }
                }
                return styles;
            },
        });
        // Outer Wall/Polygon Layer
        polygonLayerRef.current = new VectorLayer({
            source: new VectorSource(),
            style: (feature) => {
                const geometry = feature?.getGeometry();
                const type = feature?.get('type');
                const isDrawing = feature.get('isDrawing');
                const styles = [];
                // Use cached styles based on type
                switch (type) {
                    case 'RECTANGLE':
                        styles.push(polygonCachedStyles.rectangle);
                        if (!isDrawing && geometry?.getType() === 'Polygon') {
                            const coordinates = geometry.getCoordinates()[0];
                            const points = new MultiPoint(coordinates);
                            const vertexStyle = polygonCachedStyles.vertices.rectangle.clone();
                            vertexStyle.setGeometry(points);
                            styles.push(vertexStyle);
                        }
                        break;
                    case 'CIRCLE':
                        styles.push(polygonCachedStyles.circle);
                        if (!isDrawing && geometry?.getType() === 'Polygon') {
                            const coordinates = geometry.getCoordinates()[0];
                            const points = new MultiPoint(coordinates);
                            const vertexStyle = polygonCachedStyles.vertices.circle.clone();
                            vertexStyle.setGeometry(points);
                            styles.push(vertexStyle);
                        }
                        break;
                    case 'POLYGON':
                        styles.push(polygonCachedStyles.polygon.main, polygonCachedStyles.polygon.inner);
                        if (!isDrawing && geometry?.getType() === 'Polygon') {
                            const coordinates = geometry.getCoordinates()[0];
                            const points = new MultiPoint(coordinates);
                            const vertexStyle = polygonCachedStyles.vertices.polygon.clone();
                            vertexStyle.setGeometry(points);
                            styles.push(vertexStyle);
                        }
                        break;
                    case 'WALL':
                        styles.push(polygonCachedStyles.wall.shadow, polygonCachedStyles.wall.main);
                        if (!isDrawing && geometry?.getType() === 'Polygon') {
                            const coordinates = geometry.getCoordinates()[0];
                            const points = new MultiPoint(coordinates);
                            const vertexStyle = polygonCachedStyles.vertices.wall.clone();
                            vertexStyle.setGeometry(points);
                            styles.push(vertexStyle);
                        }
                        break;
                    default:
                        styles.push(polygonCachedStyles.default);
                        if (!isDrawing && geometry?.getType() === 'Polygon') {
                            const coordinates = geometry.getCoordinates()[0];
                            const points = new MultiPoint(coordinates);
                            const vertexStyle = polygonCachedStyles.vertices.default.clone();
                            vertexStyle.setGeometry(points);
                            styles.push(vertexStyle);
                        }
                }
                return styles;
            },
        });
        // Route Layer - Optimized with cached styles
        routeLayerRef.current = new VectorLayer({
            source: new VectorSource(),
            style: (feature) => {
                const geometry = feature?.getGeometry();
                const isDrawing = feature.get('isDrawing');
                const direction = feature.get('direction');
                const styles = [];
                // Use default green color for all routes
                styles.push(routeCachedStyles.shadow, routeCachedStyles.main);
                // add vertex points when not actively drawing
                if (geometry?.getType() === 'LineString' && !isDrawing) {
                    const coordinates = geometry.getCoordinates();
                    const points = new MultiPoint(coordinates);
                    const vertexStyle = routeCachedStyles.vertex.clone();
                    vertexStyle.setGeometry(points);
                    styles.push(vertexStyle);
                    // Add directional arrows based on direction property
                    if (direction === 1 || direction === 2) {
                        // Import arrow images
                        const rightArrowSrc = require('../../assets/images/right.png');
                        // Use forEachSegment
                        // Cast geometry to LineString to access forEachSegment method
                        const lineString = geometry;
                        lineString.forEachSegment(function (start, end) {
                            const dx = end[0] - start[0];
                            const dy = end[1] - start[1];
                            const rotation = Math.atan2(dy, dx);
                            // Calculate midpoint for arrow placement
                            const midPoint = [
                                (start[0] + end[0]) / 2,
                                (start[1] + end[1]) / 2
                            ];
                            // Determine arrow image and rotation based on direction
                            let arrowSrc, finalRotation;
                            if (direction === 1) {
                                // A to B direction - use right arrow
                                arrowSrc = rightArrowSrc;
                                finalRotation = -rotation; // Negative rotation
                            }
                            else {
                                // B to A direction - use left arrow (or rotate right arrow 180°)
                                arrowSrc = rightArrowSrc; // Use same image but rotate it
                                finalRotation = -rotation + Math.PI; // Add 180° rotation
                            }
                            const arrowStyle = new Style({
                                geometry: new Point(midPoint),
                                image: new OlIcon({
                                    src: arrowSrc,
                                    anchor: [0.5, 0.5],
                                    rotateWithView: true,
                                    rotation: finalRotation,
                                    scale: 1.2,
                                }),
                            });
                            styles.push(arrowStyle);
                        });
                    }
                }
                return styles;
            },
        });
        // Point Layer -  individual feature styles for text support
        pointLayerRef.current = new VectorLayer({
            source: new VectorSource(),
            // No layer-level style function - individual feature styles
        });
        // Set layer properties for better rendering
        wallLayerRef.current.set('name', 'wallLayer');
        polygonLayerRef.current.set('name', 'polygonLayer');
        routeLayerRef.current.set('name', 'routeLayer');
        pointLayerRef.current.set('name', 'pointLayer');
        // Set render order
        wallLayerRef.current.setZIndex(1);
        polygonLayerRef.current.setZIndex(2);
        routeLayerRef.current.setZIndex(3);
        pointLayerRef.current.setZIndex(4);
        map.addLayer(wallLayerRef.current);
        map.addLayer(polygonLayerRef.current);
        map.addLayer(routeLayerRef.current);
        map.addLayer(pointLayerRef.current);
    }, [map]);
    { /* Process location siblings data for point styling and labeling */ }
    useEffect(() => {
        if (locationSiblings) {
            const locationNodes = locationSiblings?.map((item) => {
                return {
                    nodeId: item?.nodeId,
                    name: item?.name,
                };
            });
            setLocationNodes(locationNodes);
        }
    }, [locationSiblings]);
    { /* Process 3D object properties for GLB and GLTF model mapping */ }
    useEffect(() => {
        if (mapObjectProperties && Array.isArray(mapObjectProperties)) {
            const mapObjectNodes = mapObjectProperties?.map((item) => {
                return {
                    nodeId: item?.nodeId,
                    name: item?.name
                };
            });
            setMapObjectPropertyNodes(mapObjectNodes);
        }
    }, [mapObjectProperties]);
    { /* Process connection data for escalators, elevators, and stairs */ }
    useEffect(() => {
        if (connections) {
            const connectionNodes = connections?.flatMap((item) => {
                // Handle case where item.node might be an array or single value
                const nodeIds = Array.isArray(item?.node) ? item.node : [item?.node];
                return nodeIds.map((nodeId) => ({
                    nodeId: nodeId,
                    name: item?.name,
                }));
            }).filter((node) => node.nodeId); // Filter out undefined nodeIds
            setConnectionNodes(connectionNodes);
        }
    }, [connections]);
    { /* Fetch nodes and route data for the currently selected floor via socket */ }
    useEffect(() => {
        if (selectedKeys && selectedKeys?.join('') !== '' && socket) {
            const id = selectedKeys?.join('');
            idRef.current = id;
            socket.emit('GET_ROUTE', {
                floorId: id,
                siteId: siteId,
            });
            socket.on('GET_ROUTE', (data) => {
                if (data && data.data) {
                    const slicedData = data?.data?.slice(1);
                    try {
                        const compressedData = pako.ungzip(slicedData, { to: 'string' });
                        const shapeResponse = JSON.parse(compressedData);
                        if ((shapeResponse?.floorId === idRef.current)) {
                            setNodesData(shapeResponse);
                        }
                    }
                    catch (error) {
                        message.error('fetching route failed');
                    }
                }
            });
        }
    }, [selectedKeys, socket]);
    { /* Clear node data when floor changes to prevent cross-floor data accumulation */ }
    useEffect(() => {
        setNodesData(null);
        // Clear existing features from layers to prevent cross-floor display
        if (pointLayerRef.current) {
            pointLayerRef.current.getSource()?.clear();
        }
        if (routeLayerRef.current) {
            routeLayerRef.current.getSource()?.clear();
        }
    }, [selectedKeys]);
    { /* Render point features and route lines on the map from nodes data */ }
    useEffect(() => {
        if (!map || !pointLayerRef.current || !routeLayerRef.current || !nodesData)
            return;
        // Clear previous features to prevent duplicates
        pointLayerRef.current?.getSource()?.clear();
        routeLayerRef.current?.getSource()?.clear();
        const highlightedNodeMap = new Map();
        const connectionNodeMap = new Map();
        const objectNodeMap = new Map();
        // Safely populate highlighted node map
        if (locationNodes && Array.isArray(locationNodes)) {
            locationNodes.forEach((node) => {
                if (node?.nodeId) {
                    highlightedNodeMap.set(node.nodeId, node);
                }
            });
        }
        // Safely populate connection node map
        if (connectionNodes && Array.isArray(connectionNodes)) {
            connectionNodes.forEach((node) => {
                if (node?.nodeId) {
                    connectionNodeMap.set(node.nodeId, node);
                }
            });
        }
        // Safely populate object node map
        if (mapObjectPropertyNodes && Array.isArray(mapObjectPropertyNodes)) {
            mapObjectPropertyNodes.forEach((node) => {
                if (node?.nodeId) {
                    objectNodeMap.set(node.nodeId, node);
                }
            });
        }
        { /*Batch process nodes to prevent UI blocking */ }
        const batchSize = 50; // Process nodes in smaller batches
        const nodeFeatures = [];
        const processNodeBatch = (startIndex) => {
            const endIndex = Math.min(startIndex + batchSize, nodesData.nodes.length);
            for (let i = startIndex; i < endIndex; i++) {
                const node = nodesData.nodes[i];
                const { nodeId, lat, lng, floorId, siteId, accessible, privateNode } = node;
                // Floor filtering handled at data source level - only current floor data is cached
                const pointFeature = new Feature({
                    geometry: new Point(fromLonLat([lng, lat])),
                });
                { /*Use Map lookup*/ }
                const highlightedNode = highlightedNodeMap.get(nodeId);
                const connectionNode = connectionNodeMap.get(nodeId);
                const objectNode = objectNodeMap.get(nodeId);
                const isHighlighted = !!highlightedNode;
                const isConnectionNode = !!connectionNode;
                const isObjectNode = !!objectNode;
                // Debug logging for node matching
                if (isHighlighted || isConnectionNode || isObjectNode) {
                    //add log for testing
                }
                const type = isHighlighted ? 'location' : isConnectionNode ? 'connection' : isObjectNode ? 'mapObject' : 'none';
                { /* Configure point feature properties for identification and filtering */ }
                pointFeature.setId(nodeId);
                pointFeature.setProperties({
                    nodeId,
                    floorId,
                    siteId,
                    accessible,
                    privateNode,
                    layerId: nodesData?.shape?.layerId,
                    type: type,
                });
                { /*Use cached styles with proper text handling */ }
                let baseStyle;
                let labelText = '';
                if (isHighlighted) {
                    baseStyle = pointCachedStyles.highlighted;
                    labelText = highlightedNode?.name || '';
                }
                else if (isConnectionNode) {
                    baseStyle = pointCachedStyles.connection;
                    labelText = connectionNode?.name || '';
                }
                else if (isObjectNode) {
                    baseStyle = pointCachedStyles.object;
                    labelText = objectNode?.name || '';
                }
                else {
                    baseStyle = pointCachedStyles.default;
                }
                // Create style with text if needed
                if (labelText) {
                    const imageStyle = baseStyle.getImage();
                    const styleWithText = new Style({
                        image: imageStyle || undefined,
                        text: new Text({
                            text: labelText,
                            font: 'bold 12px Arial',
                            fill: new Fill({ color: '#000000' }),
                            stroke: new Stroke({ color: '#FFFFFF', width: 3 }),
                            offsetY: -15,
                            textAlign: 'center',
                            textBaseline: 'bottom',
                        }),
                    });
                    pointFeature.setStyle(styleWithText);
                }
                else {
                    pointFeature.setStyle(baseStyle);
                }
                nodeFeatures.push(pointFeature);
            }
            // Add batch of features at once for better performance
            if (nodeFeatures.length > 0) {
                pointLayerRef.current?.getSource()?.addFeatures(nodeFeatures);
                nodeFeatures.length = 0; // Clear for next batch
            }
            // Process next batch asynchronously to prevent UI blocking
            if (endIndex < nodesData.nodes.length) {
                requestAnimationFrame(() => processNodeBatch(endIndex));
            }
        };
        { /* Start batch processing nodes */ }
        if (nodesData?.nodes?.length > 0) {
            processNodeBatch(0);
        }
        { /* Performance optimization: Batch process route features */ }
        const { shape } = nodesData;
        if (shape && shape?.jsonData && shape?.jsonData?.features && shape?.jsonData?.features?.length) {
            const routeFeatures = [];
            const routeBatchSize = 25; // Smaller batch for routes
            const processRouteBatch = (startIndex) => {
                const endIndex = Math.min(startIndex + routeBatchSize, shape.jsonData.features.length);
                for (let i = startIndex; i < endIndex; i++) {
                    const featureData = shape.jsonData.features[i];
                    //Floor filtering handled at data source level - only current floor data is cached
                    const routeCoordinates = featureData.geometry.coordinates.map((coord) => fromLonLat(coord));
                    const routeFeature = new Feature({
                        geometry: new LineString(routeCoordinates),
                    });
                    { /* Configure route feature properties for identification and layer management */ }
                    routeFeature.setId(featureData.properties.shapeId || featureData.id);
                    routeFeature.setProperties({
                        ...featureData.properties,
                        layerId: shape.layerId,
                        type: "route",
                    });
                    routeFeatures.push(routeFeature);
                }
                // Add batch of route features
                if (routeFeatures.length > 0) {
                    routeLayerRef.current?.getSource()?.addFeatures(routeFeatures);
                    routeFeatures.length = 0; // Clear for next batch
                }
                // Process next batch or finalize
                if (endIndex < shape.jsonData.features.length) {
                    requestAnimationFrame(() => processRouteBatch(endIndex));
                }
                else {
                    // Update route collection after all routes are processed
                    requestAnimationFrame(() => {
                        if (routeLayerRef.current) {
                            const geoJsonRoute = getGeoJson(routeLayerRef.current.getSource());
                            setRouteCollection(removeDuplicateFeatures(geoJsonRoute));
                        }
                    });
                }
            };
            processRouteBatch(0);
        }
    }, [map, nodesData, locationNodes, connectionNodes, mapObjectPropertyNodes]);
    { /*Batch process floor shapes with virtualization */ }
    useEffect(() => {
        if (!map || !wallLayerRef.current || !polygonLayerRef.current || !floorShapes)
            return;
        // Clear previous features to prevent duplicates
        wallLayerRef.current?.getSource()?.clear();
        polygonLayerRef.current?.getSource()?.clear();
        //Batch feature creation
        const batchSize = 100; // Process features in batches
        const features = [];
        const processBatch = (startIndex) => {
            const endIndex = Math.min(startIndex + batchSize, floorShapes.length);
            for (let i = startIndex; i < endIndex; i++) {
                const item = floorShapes[i];
                const { jsonData } = item;
                // Parse jsonData if it's a string
                const parsedJsonData = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
                // Floor filtering: Only show shapes for the currently selected floor
                const currentFloorId = selectedKeys?.[0];
                const shapeFloorId = parsedJsonData?.properties?.floorId;
                if (currentFloorId && shapeFloorId && shapeFloorId !== currentFloorId) {
                    continue; // Skip shapes that don't belong to the current floor
                }
                const coordinates = parsedJsonData?.geometry?.coordinates;
                let feature;
                { /* Transform coordinates from lat/lng to map projection and create appropriate geometry */ }
                if (parsedJsonData?.geometry?.type === 'Polygon') {
                    // Use typed arrays for coordinate transformation
                    const transformedCoordinates = coordinates[0]?.map((coord) => fromLonLat(coord));
                    feature = new Feature({
                        geometry: new Polygon([transformedCoordinates]),
                    });
                }
                else if (parsedJsonData?.geometry?.type === 'LineString') {
                    const transformedCoordinates = coordinates.map((coord) => fromLonLat(coord));
                    feature = new Feature({
                        geometry: new LineString(transformedCoordinates),
                    });
                }
                else if (parsedJsonData?.geometry?.type === 'Point' && parsedJsonData?.properties?.type === 'CIRCLE') {
                    { /* Handle special case: circle stored as point with radius property */ }
                    const center = fromLonLat(coordinates);
                    const radius = parsedJsonData?.properties?.radius;
                    feature = new Feature({
                        geometry: new OlCircle(center, radius),
                    });
                }
                if (feature) {
                    { /* Configure feature properties for identification and layer management */ }
                    feature.setId(item?.shapeId);
                    feature.setProperties({
                        type: parsedJsonData?.properties?.type,
                        floorId: parsedJsonData?.properties?.floorId,
                        siteId: parsedJsonData?.properties?.siteId,
                        id: parsedJsonData?.properties?.id,
                        layerId: parsedJsonData?.properties?.layerId,
                        shapeProperties: parsedJsonData?.properties?.shapeProperties || {},
                        shapeId: item?.shapeId,
                    });
                    // Add to appropriate layer based on type
                    if (parsedJsonData?.properties?.type === 'INNER_WALL') {
                        // Add inner walls to wall layer
                        wallLayerRef.current?.getSource()?.addFeature(feature);
                    }
                    else {
                        // Add other shapes to polygon layer
                        features.push(feature);
                    }
                }
            }
            // Add batch of features at once for better performance
            if (features.length > 0) {
                polygonLayerRef.current?.getSource()?.addFeatures(features);
                features.length = 0; // Clear array for next batch
            }
            // Process next batch asynchronously to prevent UI blocking
            if (endIndex < floorShapes.length) {
                requestAnimationFrame(() => processBatch(endIndex));
            }
        };
        // Start batch processing
        if (floorShapes.length > 0) {
            processBatch(0);
        }
    }, [map, floorShapes]);
    { /* Fetch and process layer configuration for the selected floor */ }
    useEffect(() => {
        if (siteLayers && selectedKeys) {
            const selectedFloorId = selectedKeys?.join('');
            const selectedFloorLayers = siteLayers?.response;
            function filterByKey(data, key) {
                return data[key];
            }
            if (selectedFloorLayers) {
                const result = filterByKey(selectedFloorLayers, selectedFloorId);
                setFloorLayerData(result);
            }
        }
    }, [selectedKeys, siteLayers]);
    { /* Initialize layer branches for the tree structure navigation */ }
    useEffect(() => {
        if (floorLayerData && !layerAdded) {
            const initialBranches = floorLayerData?.map((layer) => layer?.name);
            setBranches(initialBranches);
            setSelectedBranch(initialBranches && initialBranches?.length && initialBranches[0]);
        }
    }, [floorLayerData]);
    { /* Update selected layer data when branch selection changes */ }
    useEffect(() => {
        if (selectedBranch && floorLayerData) {
            const filteredData = floorLayerData?.find((item) => item?.name === selectedBranch);
            setSelectedLayerData(filteredData);
            setLayerAdded(false);
        }
    }, [selectedBranch, floorLayerData]);
    { /* Reset active tool to select mode when switching between layers */ }
    useEffect(() => {
        setActiveTool('select');
    }, [selectedBranch]);
    { /* Initialize site-specific data by dispatching multiple actions */ }
    useEffect(() => {
        if (siteId) {
            dispatch(fetchLocationStates(siteId));
            dispatch(fetchLocationZones(siteId));
            dispatch(fetchLocationSiblings(siteId));
            dispatch(fetchLocationCategories(siteId));
            dispatch(fetchSiteLayers(siteId));
            dispatch(getConnectionsAction(siteId));
            dispatch(fetchEvents(siteId));
            dispatch(getMap3DObjectsAction(siteId));
            dispatch(getMap3DObjectPropertiesAction(siteId));
            dispatch(getSupportedLanguagesAction());
            dispatch(getSiteLanguagesAction(siteId));
        }
    }, [siteId]);
    { /* Fetch category icons for location categorization */ }
    useEffect(() => {
        dispatch(getCategoriesIconAction());
    }, []);
    { /* Fetch all existing floor shapes for the selected floor */ }
    useEffect(() => {
        if (siteId && selectedKeys?.length) {
            dispatch(getFloorShapeAction({ siteId, floorId: selectedKeys[0] }));
            dispatch(fetchNodesBySiteAndFloor({ siteId, floorId: selectedKeys[0] }));
        }
    }, [selectedKeys, siteId]);
    { /* Manage visual styling for selected connection nodes */ }
    useEffect(() => {
        if (selectedConnectionNode && selectedConnectionNode?.values_?.type === 'none') {
            // Restore the previous node's style if it exists
            if (previousStyle?.feature) {
                previousStyle.feature.setStyle(previousStyle.style);
            }
            // Store the current node's style before applying black
            const currentStyle = selectedConnectionNode.getStyle();
            setPreviousStyle({
                feature: selectedConnectionNode,
                style: currentStyle,
            });
            { /* Apply highlighting to the currently selected connection node */ }
            selectedConnectionNode.setStyle(new Style({
                image: new CircleStyle({
                    radius: 6,
                    fill: new Fill({ color: '#1F2937' }),
                    stroke: new Stroke({ color: '#FBBF24', width: 2 }), // Amber outline, reduced width
                }),
            }));
        }
    }, [selectedConnectionNode]);
    { /* Handle route selection and style start/end points */ }
    useEffect(() => {
        if (!pointLayerRef.current)
            return;
        // First, restore previous start/end point styles if they exist
        if (routeEndPointStyles.startPoint) {
            routeEndPointStyles.startPoint.feature.setStyle(routeEndPointStyles.startPoint.originalStyle);
        }
        if (routeEndPointStyles.endPoint) {
            routeEndPointStyles.endPoint.feature.setStyle(routeEndPointStyles.endPoint.originalStyle);
        }
        // Clear the stored styles
        setRouteEndPointStyles({});
        // Check if selected feature is a route
        if (selectedFeatures?.getProperties()?.type === 'route') {
            const geometry = selectedFeatures.getGeometry();
            if (geometry?.getType() === 'LineString') {
                const coordinates = geometry.getCoordinates();
                if (coordinates.length >= 2) {
                    const startCoord = coordinates[0];
                    const endCoord = coordinates[coordinates.length - 1];
                    // Get all point features
                    const pointFeatures = pointLayerRef.current.getSource()?.getFeatures() || [];
                    const newEndPointStyles = {};
                    pointFeatures.forEach((pointFeature) => {
                        const pointGeom = pointFeature.getGeometry();
                        if (pointGeom?.getType() === 'Point') {
                            const pointCoord = pointGeom.getCoordinates();
                            // Check if this point matches start coordinate
                            const tolerance = 1e-6;
                            const isStartPoint = Math.abs(pointCoord[0] - startCoord[0]) < tolerance &&
                                Math.abs(pointCoord[1] - startCoord[1]) < tolerance;
                            // Check if this point matches end coordinate
                            const isEndPoint = Math.abs(pointCoord[0] - endCoord[0]) < tolerance &&
                                Math.abs(pointCoord[1] - endCoord[1]) < tolerance;
                            if (isStartPoint) {
                                // Store original style before changing
                                const originalStyle = pointFeature.getStyle();
                                newEndPointStyles.startPoint = {
                                    feature: pointFeature,
                                    originalStyle: originalStyle
                                };
                                // Style start point with white color and "A" text
                                pointFeature.setStyle(new Style({
                                    image: new CircleStyle({
                                        radius: 12,
                                        fill: new Fill({ color: '#FFFFFF' }),
                                        stroke: new Stroke({ color: '#000000', width: 2 }),
                                    }),
                                    text: new Text({
                                        text: 'A',
                                        font: 'bold 14px Arial',
                                        fill: new Fill({ color: '#000000' }),
                                        textAlign: 'center',
                                        textBaseline: 'middle',
                                    }),
                                }));
                            }
                            else if (isEndPoint) {
                                // Store original style before changing
                                const originalStyle = pointFeature.getStyle();
                                newEndPointStyles.endPoint = {
                                    feature: pointFeature,
                                    originalStyle: originalStyle
                                };
                                // Style end point with pink color and "B" text
                                pointFeature.setStyle(new Style({
                                    image: new CircleStyle({
                                        radius: 12,
                                        fill: new Fill({ color: '#EC4899' }),
                                        stroke: new Stroke({ color: '#000000', width: 2 }),
                                    }),
                                    text: new Text({
                                        text: 'B',
                                        font: 'bold 14px Arial',
                                        fill: new Fill({ color: '#FFFFFF' }),
                                        textAlign: 'center',
                                        textBaseline: 'middle',
                                    }),
                                }));
                            }
                        }
                    });
                    // Store the new endpoint styles for future restoration
                    setRouteEndPointStyles(newEndPointStyles);
                }
            }
        }
    }, [selectedFeatures]);
    { /* Configure map interactions based on the currently active drawing/editing tool */ }
    useEffect(() => {
        if (!map)
            return;
        { /* Log interactions before removal */ }
        logActiveInteractions('BEFORE REMOVAL');
        { /* Remove any existing map interactions to prevent conflicts */ }
        removeMapInteractions();
        { /* Configure interactions based on the currently selected tool */ }
        const interactions = setupToolInteractions();
        { /* Apply the new interactions to the map */ }
        addInteractionsToMap(interactions);
        { /* Log interactions after addition */ }
        logActiveInteractions('AFTER ADDITION');
        { /* Manage point layer visibility for specific tools */ }
        handlePointLayerVisibility();
        { /* Cleanup function to prevent memory leaks and interaction conflicts */ }
        return () => {
            removeMapInteractions();
            if (pointLayerRef.current) {
                pointLayerRef.current.setVisible(true);
            }
            setSelectedFeatures(null);
        };
    }, [map, activeTool, selectedKeys, selectedLayerData, selectedSidebar]);
    { /*UTILITY FUNCTIONS*/ }
    { /* Remove all drawing and selection interactions from the map */ }
    // Log all active interactions on the map
    const logActiveInteractions = (context) => {
        if (!map)
            return;
        const allInteractions = map.getInteractions().getArray();
        const relevantInteractions = allInteractions.filter(interaction => {
            // Add null check to prevent errors
            if (!interaction || !interaction.constructor) {
                return false;
            }
            const interactionName = interaction.constructor.name;
            const isSplitter = interaction instanceof SplitterInteraction ||
                interactionName.includes('Splitter') ||
                interactionName.includes('splitter');
            return interaction instanceof DrawInteraction ||
                interaction instanceof SelectInteraction ||
                interaction instanceof SplitterInteraction ||
                interaction instanceof Snap ||
                interaction instanceof SnapGuides ||
                interaction instanceof Modify ||
                isSplitter;
        });
        const splitters = relevantInteractions.filter(i => {
            if (!i || !i.constructor)
                return false;
            const interactionName = i.constructor.name;
            return i instanceof SplitterInteraction ||
                interactionName.includes('Splitter') ||
                interactionName.includes('splitter');
        });
    };
    const removeMapInteractions = () => {
        if (!map)
            return;
        let removedCount = 0;
        // Use getArray() to get a snapshot of interactions
        const allInteractions = map.getInteractions().getArray().slice(); // Create a copy
        // First, identify all interactions to remove
        const interactionsToRemove = [];
        allInteractions.forEach((interaction, index) => {
            // Add null check to prevent errors
            if (!interaction || !interaction.constructor) {
                return;
            }
            const interactionName = interaction.constructor.name;
            // Check for splitter by name as well as instanceof
            const isSplitter = interaction instanceof SplitterInteraction ||
                interactionName.includes('Splitter') ||
                interactionName.includes('splitter');
            if (interaction instanceof DrawInteraction ||
                interaction instanceof SelectInteraction ||
                interaction instanceof SplitterInteraction ||
                interaction instanceof Snap ||
                interaction instanceof SnapGuides ||
                interaction instanceof Modify ||
                isSplitter // Additional splitter check
            ) {
                interactionsToRemove.push({ interaction, name: interactionName, isSplitter });
            }
        });
        // Now remove all identified interactions
        interactionsToRemove.forEach(({ interaction, name, isSplitter }) => {
            map.removeInteraction(interaction);
            removedCount++;
        });
    };
    // Add interactions to map
    const addInteractionsToMap = (interactions) => {
        if (!map)
            return;
        Object.entries(interactions).forEach(([key, interaction]) => {
            if (interaction) {
                // Special logging for splitter
                if (interaction instanceof SplitterInteraction) {
                    // Add split event listener to catch any splits
                    interaction.on('split', (event) => {
                        //split features
                    });
                }
                map.addInteraction(interaction);
            }
        });
    };
    // Handle point layer visibility for modify tool
    const handlePointLayerVisibility = () => {
        if (activeTool === 'modify') {
            if (pointLayerRef.current && selectedLayerData?.name === 'Route Layer') {
                pointLayerRef.current.setVisible(false);
            }
        }
    };
    // INTERACTION SETUP FUNCTIONS
    // Main function to setup interactions based on active tool
    const setupToolInteractions = () => {
        const interactions = {};
        switch (activeTool) {
            case 'modify':
                const modifyInteractions = setupModifyInteraction();
                if (modifyInteractions) {
                    Object.assign(interactions, modifyInteractions);
                }
                break;
            case 'route':
                Object.assign(interactions, setupRouteInteraction());
                break;
            case 'rectangle':
                interactions.draw = setupRectangleInteraction();
                break;
            case 'circle':
                interactions.draw = setupCircleInteraction();
                break;
            case 'custom':
                Object.assign(interactions, setupCustomPolygonInteraction());
                break;
            case 'wall':
                Object.assign(interactions, setupWallInteraction());
                break;
            case 'innerWall':
                Object.assign(interactions, setupInnerWallInteraction());
                break;
            case 'select':
                interactions.select = setupSelectInteraction();
                break;
            case 'selectNode':
                interactions.select = setupSelectNodeInteraction();
                break;
            case 'delete':
                interactions.draw = setupDeleteInteraction();
                break;
            default:
                break;
        }
        return interactions;
    };
    // Setup modify interaction
    const setupModifyInteraction = () => {
        const allFeaturesToModify = [routeLayerRef, wallLayerRef, polygonLayerRef, pointLayerRef]
            .map((layerRef) => layerRef.current?.getSource()?.getFeatures() || [])
            .flat()
            .filter((feature) => feature.get('layerId') === selectedLayerData?.layerId);
        if (allFeaturesToModify.length === 0)
            return null;
        const selectedFeatures = new Collection(allFeaturesToModify);
        const modify = new Modify({ features: selectedFeatures });
        modify.on('modifyend', handleModifyEnd);
        // Add snapping support for modify interaction
        const interactions = { modify };
        // For route layer, add comprehensive snapping support
        if (selectedLayerData?.name === 'Route Layer') {
            const vectorSource = routeLayerRef.current?.getSource();
            // Add snap to route points and other routes
            const snap = new Snap({ source: vectorSource });
            // Add snap guides for visual feedback with modern styling
            const snapGuide = new SnapGuides({
                vectorClass: VectorLayer,
                style: new Style({
                    stroke: new Stroke({
                        color: '#F59E0B',
                        width: 2,
                        lineDash: [4, 4],
                    }),
                }),
            });
            snapGuide.setModifyInteraction(modify);
            interactions.snap = snap;
            interactions.snapGuide = snapGuide;
        }
        //commented this section for future enhancement
        // else {
        //   // For other layers, add basic snapping to their own features
        //   const layerSource = selectedLayerData?.name === 'Outer Wall'
        //     ? polygonLayerRef.current?.getSource()
        //     : wallLayerRef.current?.getSource();
        //   if (layerSource) {
        //     const snap = new Snap({ source: layerSource });
        //     interactions.snap = snap;
        //   }
        // }
        return interactions;
    };
    // Handle modify end event
    const handleModifyEnd = async (event) => {
        // Check modifying route layer
        if (selectedLayerData?.name === 'Route Layer') {
            // For routes, just update the route collection - don't auto-save individual features
            // Routes are saved manually when user clicks "Save Route" button
            setTimeout(() => {
                if (routeLayerRef.current) {
                    // Remove duplicates directly from source first
                    const geoJsonRoute = getGeoJson(routeLayerRef.current.getSource());
                    setRouteCollection(removeDuplicateFeatures(geoJsonRoute));
                    updatePointsToVertices(routeLayerRef.current.getSource()?.getFeatures() || [], pointLayerRef, selectedLayerData);
                }
            }, 100);
        }
        else {
            // For non-route features, save each modified feature individually
            for (const feature of event.features.getArray()) {
                const geojsonFeature = createGeoJSONFromFeature(feature);
                if (geojsonFeature) {
                    try {
                        await saveShape(JSON.stringify(geojsonFeature, null, 2), socket);
                    }
                    catch (error) {
                        //error
                    }
                }
            }
        }
    };
    // Setup route interaction
    const setupRouteInteraction = () => {
        const vectorSource = routeLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'LineString',
        });
        draw.on('drawstart', handleDrawStart);
        draw.on('drawend', handleRouteDrawEnd);
        const snap = new Snap({ source: vectorSource });
        const snapGuide = new SnapGuides({
            vectorClass: VectorLayer,
            style: new Style({
                stroke: new Stroke({
                    color: '#F59E0B',
                    width: 2,
                    lineDash: [4, 4],
                }),
            }),
        });
        snapGuide.setDrawInteraction(draw);
        snapGuide.setModifyInteraction(draw);
        // DYNAMIC SPLITTER: Add during drawing, remove during modify
        const split = new SplitterInteraction({
            source: vectorSource,
            tolerance: 1e-3,
        });
        split.on('split', (event) => {
            //event
        });
        return { draw, snap, snapGuide, split };
    };
    //Handle draw start to mark features as drawing
    const handleDrawStart = (event) => {
        const feature = event.feature;
        feature.set('isDrawing', true);
    };
    // Handle route draw end (no auto-save for routes)
    const handleRouteDrawEnd = (event) => {
        const feature = event.feature;
        // Remove drawing flag for performance optimization
        feature.set('isDrawing', false);
        // Duplicate removal is handled in the timeout below using removeDuplicatesFromSource
        feature.setProperties({
            ...feature.getProperties(),
            layerId: selectedLayerData?.layerId,
            type: "route",
            accessible: false,
            private: false,
            direction: 0
        });
        // Force style refresh after drawing is complete
        feature.changed();
        setTimeout(() => {
            if (routeLayerRef.current) {
                // Remove duplicates directly from source first
                const duplicatesRemoved = removeDuplicatesFromSource(routeLayerRef.current.getSource());
                const geoJsonRoute = getGeoJson(routeLayerRef.current.getSource());
                setRouteCollection(removeDuplicateFeatures(geoJsonRoute));
                updatePointsToVertices(routeLayerRef.current.getSource()?.getFeatures() || [], pointLayerRef, selectedLayerData);
            }
        }, 100);
    };
    // Setup rectangle interaction
    const setupRectangleInteraction = () => {
        const vectorSource = polygonLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'Circle',
            geometryFunction: createBox(),
        });
        draw.on('drawend', (event) => handlePolygonDrawEnd(event, 'RECTANGLE', selectedKeys, siteId || '', selectedLayerData, socket));
        return draw;
    };
    // Setup circle interaction
    const setupCircleInteraction = () => {
        const vectorSource = polygonLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'Circle',
            geometryFunction: (coordinates, geometry) => {
                const center = coordinates[0];
                const newRadius = Math.sqrt(Math.pow(coordinates[1][0] - center[0], 2) + Math.pow(coordinates[1][1] - center[1], 2));
                if (!geometry) {
                    return new OlCircle(center, newRadius);
                }
                else {
                    geometry.setCenter(center);
                    geometry.setRadius(newRadius);
                    return geometry;
                }
            },
        });
        draw.on('drawend', (event) => handleCircleDrawEnd(event, selectedKeys, siteId || '', selectedLayerData, socket));
        return draw;
    };
    // Setup custom polygon interaction
    const setupCustomPolygonInteraction = () => {
        const vectorSource = polygonLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'Polygon',
        });
        draw.on('drawend', (event) => handlePolygonDrawEnd(event, 'POLYGON', selectedKeys, siteId || '', selectedLayerData, socket));
        const snap = new Snap({ source: vectorSource });
        const snapGuide = new SnapGuides({
            vectorClass: VectorLayer,
            style: new Style({
                stroke: new Stroke({
                    color: '#F59E0B',
                    width: 2,
                    lineDash: [4, 4],
                }),
            }),
        });
        snapGuide.setDrawInteraction(draw);
        return { draw, snap, snapGuide };
    };
    // Setup wall interaction
    const setupWallInteraction = () => {
        const vectorSource = polygonLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'Polygon',
        });
        draw.on('drawend', (event) => handlePolygonDrawEnd(event, 'WALL', selectedKeys, siteId || '', selectedLayerData, socket));
        const snap = new Snap({ source: vectorSource });
        const snapGuide = new SnapGuides({
            vectorClass: VectorLayer,
            style: new Style({
                stroke: new Stroke({
                    color: '#F59E0B',
                    width: 2,
                    lineDash: [4, 4],
                }),
            }),
        });
        snapGuide.setDrawInteraction(draw);
        snapGuide.setModifyInteraction(draw);
        return { draw, snap, snapGuide };
    };
    // Setup inner wall interaction
    const setupInnerWallInteraction = () => {
        const vectorSource = wallLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'LineString',
            style: new Style({
                stroke: new Stroke({
                    color: '#8B5CF6',
                    width: 5,
                    lineCap: 'round',
                    lineJoin: 'round',
                    lineDash: [12, 6],
                }),
            }),
        });
        draw.on('drawend', (event) => handleLineStringDrawEnd(event, 'INNER_WALL', selectedKeys, siteId || '', selectedLayerData, socket));
        //snap to walls and polygons only (no routes)
        const snap = new Snap({
            source: vectorSource // Inner walls snap to themselves
        });
        const snapGuide = new SnapGuides({
            vectorClass: VectorLayer,
            style: new Style({
                stroke: new Stroke({
                    color: '#F59E0B',
                    width: 2,
                    lineDash: [4, 4],
                }),
            }),
        });
        snapGuide.setDrawInteraction(draw);
        snapGuide.setModifyInteraction(draw);
        // Return interactions with snapping to walls and polygons only
        const interactions = { draw, snap, snapGuide };
        // Add snapping to polygon layer (outer walls, custom shapes) only
        if (polygonLayerRef.current?.getSource()) {
            interactions.polygonSnap = new Snap({
                source: polygonLayerRef.current.getSource()
            });
        }
        return interactions;
    };
    // Setup select interaction
    const setupSelectInteraction = () => {
        const select = new SelectInteraction({
            filter: (feature) => feature.get('layerId') === selectedLayerData?.layerId,
        });
        select.on('select', handleFeatureSelect);
        return select;
    };
    // Setup select node interaction
    const setupSelectNodeInteraction = () => {
        const select = new SelectInteraction({
            filter: (feature, layer) => layer === pointLayerRef.current,
        });
        select.on('select', handleNodeSelect);
        return select;
    };
    // Setup delete interaction
    const setupDeleteInteraction = () => {
        const vectorSource = polygonLayerRef.current?.getSource();
        const draw = new DrawInteraction({
            source: vectorSource,
            type: 'Polygon',
        });
        draw.on('drawend', () => { });
        return draw;
    };
    //SELECTION HANDLERS
    // Handle feature selection
    const handleFeatureSelect = (e) => {
        const selectedFeature = e.selected[0];
        // Check if the selected feature is a point and if it's an unsaved node
        if (selectedFeature && selectedFeature?.getGeometry().getType() === 'Point') {
            const nodeId = selectedFeature?.getProperties()?.nodeId;
            // Check if it's an unsaved node
            if (!nodeId) {
                message.warning('Save node to add properties to it');
                return; // Don't set selectedFeatures
            }
        }
        setSelectedFeatures(selectedFeature);
        // Check if the selected feature is a point
        if (selectedFeature && selectedFeature?.getGeometry().getType() === 'Point') {
            const pointCoordinate = selectedFeature?.getGeometry().getCoordinates();
            // Loop through all polygons in the polygonLayer to check for containment
            const polygonFeatures = polygonLayerRef.current?.getSource()?.getFeatures() || [];
            const enclosingPolygons = [];
            polygonFeatures.forEach((polygonFeature) => {
                const polygonGeometry = polygonFeature.getGeometry();
                // Check if the point is within the polygon
                if (polygonGeometry?.intersectsCoordinate && polygonGeometry.intersectsCoordinate(pointCoordinate)) {
                    enclosingPolygons.push(polygonFeature);
                }
            });
        }
    };
    // Handle node selection
    const handleNodeSelect = (e) => {
        const selectedFeature = e.selected[0];
        setSelectedConnectionNode(selectedFeature);
        let selectedNode = selectedFeature?.values_?.nodeId || null;
        const selectedFeatureType = selectedFeature?.values_?.type || null;
        let enclosingPolygon = null;
        if (selectedFeatureType === 'none') {
            if (selectedFeature && selectedFeature?.getGeometry().getType() === 'Point') {
                const pointCoordinate = selectedFeature?.getGeometry().getCoordinates();
                // Loop through all polygons in the polygonLayer to check for containment
                const polygonFeatures = polygonLayerRef.current?.getSource()?.getFeatures() || [];
                const enclosingPolygons = [];
                polygonFeatures.forEach((polygonFeature) => {
                    const polygonGeometry = polygonFeature.getGeometry();
                    // Check if the point is within the polygon
                    if (polygonGeometry?.intersectsCoordinate && polygonGeometry.intersectsCoordinate(pointCoordinate)) {
                        enclosingPolygons.push(polygonFeature);
                    }
                });
                if (enclosingPolygons.length > 0) {
                    // Handle the case where one or more polygons enclose the point
                    if (enclosingPolygons?.length > 1) {
                        enclosingPolygon = enclosingPolygons
                            ?.filter((item) => item?.values_?.type === 'POLYGON')
                            ?.filter((item) => item?.values_?.shapeProperties?.height)
                            ?.reduce((maxItem, currentItem) => {
                            return currentItem.values_.shapeProperties.height > (maxItem?.values_?.shapeProperties?.height || 0)
                                ? currentItem
                                : maxItem;
                        }, null);
                    }
                    else if (enclosingPolygons?.length === 1) {
                        enclosingPolygon = enclosingPolygons
                            ?.filter((item) => item?.values_?.type === 'POLYGON')
                            ?.filter((item) => item?.values_?.shapeProperties?.height)
                            ?.reduce((maxItem, currentItem) => {
                            return currentItem.values_.shapeProperties.height > (maxItem?.values_?.shapeProperties?.height || 0)
                                ? currentItem
                                : maxItem;
                        }, null);
                    }
                }
            }
            if (activeFormRef.current) {
                activeFormRef.current.setFieldsValue({
                    nodeId: selectedNode,
                    polygonId: enclosingPolygon?.getProperties()?.shapeId || null,
                });
            }
            if (selectedNodeIndex !== null) {
                // Update only the specific nodeId field at `selectedNodeIndex`
                const currentNodes = formConnection.getFieldValue('nodeIds') || [];
                currentNodes[selectedNodeIndex] = selectedNode; // Set selected node ID at the specified index
                formConnection.setFieldsValue({
                    nodeIds: currentNodes,
                });
            }
            //select node for map 3d object   
            mapObjectForm.setFieldsValue({
                nodeId: selectedNode
            });
            message.success('Node Selected');
            setActiveTool('select');
            setSelectNode(false);
        }
        else if (!selectedFeatureType) {
            message.warning('Selected node is not saved');
        }
        else {
            message.warning('Node is already tagged');
        }
    };
    { /*creating the building tree data*/ }
    useEffect(() => {
        const fetchBuildingsAndFloors = async () => {
            if (!siteId)
                return;
            const response = await dispatch(getBuildingAction(siteId));
            const data = response?.payload;
            const content = data?.data?.content ?? [];
            if (content.length > 0) {
                const floorPromises = content.map(async (item, index) => {
                    const floorResponse = await dispatch(getFloorAction({ siteId, data: { buildingId: item?.buildingId, pageSize: 50 } }));
                    return {
                        title: item?.name,
                        key: `${item?.buildingId}`,
                        icon: _jsx(Icon, { icon: "building-01", size: 14 }),
                        selectable: false,
                        buildingData: item,
                        children: floorResponse?.payload?.data?.content
                            ?.slice()
                            ?.reverse()
                            ?.map((floorItem) => ({
                            title: floorItem?.shortName,
                            key: floorItem?.floorId,
                            icon: _jsx(Icon, { icon: "image-01", size: 14 }),
                            floorData: floorItem,
                        })),
                    };
                });
                const buildingsWithFloors = await Promise.all(floorPromises);
                setBuildingTree(buildingsWithFloors);
                if (buildingsWithFloors.length > 0 && buildingsWithFloors[0].children.length > 0) {
                    const floorId = getQueryParam('floor');
                    const firstBuildingKey = buildingsWithFloors[0].key;
                    const firstFloorKey = floorId || buildingsWithFloors[0].children[0].key;
                    const floorData = buildingsWithFloors[0].children.find((item) => item.key === (floorId || firstFloorKey));
                    const firstFloorData = {
                        title: floorData?.title,
                        rotation: floorData?.floorData?.rotation,
                    };
                    setExpandedKeys([firstBuildingKey]);
                    setSelectedKeys([firstFloorKey]);
                    setFloorName(firstFloorData?.title);
                    setRotation(firstFloorData?.rotation || 0);
                }
            }
        };
        fetchBuildingsAndFloors();
    }, [siteId, dispatch]);
    { /*end side effects*/ }
    { /*define all helper functions here*/ }
    { /*handles the selection of the floor*/ }
    const handleSelect = (selectedKeys) => {
        const selectedTitles = getSelectedTitles(selectedKeys, buildingTree, findTitle);
        setSelectedKeys(selectedKeys);
        setFloorName(selectedTitles[0]?.title || '');
        setRotation(selectedTitles[0]?.rotation || 0);
        setQueryParam('floor', selectedKeys?.join(''));
    };
    { /*handles the selection of the shape*/ }
    const selectShape = (shape) => {
        if (activeTool == shape)
            return;
        selectTool(shape);
        setLastUsedShape(shape);
    };
    { /*handles the expansion of the tree*/ }
    const onExpand = (expandedKeysValue) => {
        setExpandedKeys(expandedKeysValue);
    };
    { /*handles the selection of the sidebar*/ }
    const setSideBar = useCallback((key) => {
        setQueryParam('panel', key);
        setSeletedSidebar(key);
        setEditLocation(null);
        setEditConnection(null);
        setEditCategory(null);
        setEditEvent(null);
        setEditMappedThreedObject(null);
    }, [setQueryParam]);
    { /*handles the selection of the menu*/ }
    const handleMenuClick = (e) => {
        const selected = items?.find((item) => item?.key === e?.key);
        if (selected) {
            setSelectedDropdownItem(selected);
        }
    };
    { /*handles the saving of the route*/ }
    const saveRoute = useCallback(async () => {
        const routeLayerId = floorLayerData?.find((it) => it.name === 'Route Layer')?.layerId;
        if (!routeLayerId) {
            message.error('No Route Layer Found');
            return;
        }
        const data = {
            siteId: siteId,
            floorId: selectedKeys?.join(''),
            layerId: routeLayerId,
            routeGeoJson: routeCollection,
        };
        saveRouteData(data, socket, pointLayerRef, setNodesData, setRouteFlag, dispatch);
    }, [routeCollection, selectedKeys, siteId, floorLayerData, socket]);
    useEffect(() => {
        layerRef.current = selectedLayerData?.layerId;
    }, [selectedLayerData]);
    { /*handles the addition of the new branch*/ }
    const handleAddBranch = async (inputValue) => {
        if (inputValue && !branches.includes(inputValue) && siteId && selectedKeys) {
            const floorId = selectedKeys?.join('');
            const newLayerData = {
                siteId,
                floorId,
                name: inputValue,
            };
            // Dispatch the action to create a new layer
            const resultAction = await dispatch(createSiteLayers(newLayerData));
            if (createSiteLayers.fulfilled.match(resultAction)) {
                // Refetch layers after successful creation
                await dispatch(fetchSiteLayers(siteId));
                // Update the local state with the new layer data
                const newBranches = [...branches, inputValue];
                setBranches(newBranches);
                // setFilteredBranches(newBranches);
                setSelectedBranch(inputValue); // Select the newly created layer
                // setInputValue('');
                setLayerAdded(true);
            }
        }
    };
    // Delete selected features
    const deleteSelectedFeaturesLocal = () => {
        deleteSelectedFeatures(selectedFeatures, selectedLayerData, routeLayerRef, pointLayerRef, polygonLayerRef, wallLayerRef, socket, siteId || '', setSelectedFeatures, setRouteCollection, updatePointsToVertices);
    };
    const hideFeaturesLocal = (layerName = null) => {
        const layerRefs = [routeLayerRef, wallLayerRef, polygonLayerRef, pointLayerRef];
        hideFeatures(layerRefs, floorLayerData, selectedLayerData, originalStylesRef, layerName);
    };
    const unhideFeaturesLocal = (layerName = null) => {
        const layerRefs = [routeLayerRef, wallLayerRef, polygonLayerRef, pointLayerRef];
        unhideFeatures(layerRefs, floorLayerData, selectedLayerData, originalStylesRef, layerName);
    };
    const selectTool = (tool = null) => {
        setActiveTool(tool);
    };
    //socket
    const totalSteps = 7;
    const handleBuild = () => {
        if (!siteId)
            return;
        setBuildFlag(true);
        buildSite(socket, siteId, totalSteps, () => setBuildFlag(false));
    };
    const updateStateData = () => {
        setSelectNode(true);
        setActiveTool('selectNode');
    };
    const treeStructure = (_jsx("div", { className: "bc-dropdown", children: _jsx("div", { className: "bc-dropdown-menu", style: { padding: 10 }, children: _jsx(LayersTree, { showLine: true, defaultExpandAll: true, treeData: buildingTree || [], selectedKeys: selectedKeys, expandedKeys: expandedKeys, onSelect: handleSelect, onExpand: onExpand }) }) }));
    const onBackLocationPanel = useCallback(() => {
        setSeletedSidebar('locations');
        setEditLocation(null);
        if (selectedConnectionNode && previousStyle?.style) {
            selectedConnectionNode.setStyle(previousStyle.style);
            setSelectedConnectionNode(null);
            setPreviousStyle(null);
        }
    }, [selectedConnectionNode, previousStyle]);
    const onBackCategoryPanel = useCallback(() => {
        setSeletedSidebar('categories');
        setEditCategory(null);
    }, []);
    const onBackEventPanel = useCallback(() => {
        setSeletedSidebar('events');
        setEditEvent(null);
    }, []);
    const isOpenCategoryPanel = useMemo(() => {
        return selectedSidebar === 'newCategory' || !!editCategory;
    }, [selectedSidebar, editCategory]);
    const isOpenEventPanel = useMemo(() => {
        return selectedSidebar === 'newEvent' || !!editEvent;
    }, [selectedSidebar, editEvent]);
    const selctNodeLocationPanel = useCallback((form) => {
        activeFormRef.current = form;
        setSelectNode(true);
        setActiveTool('selectNode');
    }, []);
    const userName = useMemo(() => {
        if (!userDetails)
            return 'U';
        const text = userDetails?.firstName[0] + (userDetails?.lastName[0] || '');
        return text || 'U';
    }, [userDetails]);
    if (buildingDataLoading || floorDataLoading) {
        return (_jsx(Spin, { size: "large", children: _jsx("div", { style: { height: '100vh', width: '100%' } }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(EditorWrapper, { children: _jsx(Editorcontainer, { children: _jsxs(EditorcontainerTools, { children: [_jsxs(EditorHeader, { children: [_jsx(EditorHeaderSection, { children: _jsxs(EditorTools, { orientation: "horizontal", style: { outline: 'none' }, children: [_jsx(EditorHeaderItem, { hasBorder: true, style: { marginInline: '8px' }, children: _jsx(AntdButton, { className: "sq", color: "default", variant: "text", icon: _jsx(Icon, { icon: "menu-02", size: 20 }) }) }), _jsx(EditorHeaderItem, { children: _jsx("img", { src: becoLogo, alt: "becomap", height: 22 }) }), _jsx(Divider, { type: "vertical", style: { height: '24px' } }), _jsx(EditorHeaderItem, { hasBorder: true, style: { marginInline: '8px' }, children: _jsx(Dropdown, { trigger: ['click'], menu: {
                                                            items,
                                                            selectable: true,
                                                            defaultSelectedKeys: [selectedDropdownItem?.key || items[0]?.key],
                                                            onClick: handleMenuClick,
                                                        }, placement: "bottomRight", children: _jsxs(HeaderMenuItem, { children: [_jsxs(HeaderMenuItemDropdown, { children: [selectedDropdownItem?.icon, selectedDropdownItem?.label] }), _jsx(HeaderMenuItemDropdownAction, { children: _jsx(Icon, { icon: "chevron-down", size: 16 }) })] }) }) })] }) }), _jsx(EditorHeaderSection, {}), _jsxs(EditorHeaderSection, { children: [_jsxs(EditorHeaderSection, { style: { marginInline: '8px' }, children: [_jsx(Button, { color: "gray", variant: "solid", icon: _jsx(Icon, { icon: "save-02", size: 20 }), style: { marginRight: '8px' }, onClick: () => {
                                                            saveRoute();
                                                        }, children: "Save Route" }), _jsx(Button, { onClick: () => {
                                                            handleBuild();
                                                        }, color: "primary", variant: "solid", icon: _jsx(Icon, { icon: "terminal-browser", size: 20 }), children: "Build" })] }), _jsx(EditorHeaderItem, { hasBorder: true, style: { marginInline: '8px' }, children: _jsx(Dropdown, { trigger: ['click'], menu: {
                                                        items: profileItems,
                                                        selectable: true,
                                                    }, placement: "bottomRight", children: _jsx(AntdButton, { className: "sq", color: "default", variant: "text", children: userName }) }) })] })] }), _jsxs(EditorContent, { children: [_jsxs(EditorToolArea, { children: [_jsx(ToolBar, { children: _jsx(ToolBarInner, { children: _jsxs(Tools, { children: [_jsx(SingleTool, { selected: activeTool === 'select', children: _jsx(Tooltip, { title: "Select (V)", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => selectTool('select'), icon: "cursor-01", size: 24 }) }) }) }), _jsx(SingleTool, { selected: activeTool === null, children: _jsx(Tooltip, { title: "Pan (space)", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => selectTool(), icon: "hand", size: 24 }) }) }) }), selectedBranch === 'Outer Wall' ? (_jsx(SingleTool, { selected: activeTool === 'wall', children: _jsx(Tooltip, { title: "Wall (W)", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => {
                                                                                selectTool('wall');
                                                                                setSelectedBranch('Outer Wall');
                                                                            }, icon: "Wall", size: 22 }) }) }) })) : null, selectedBranch === 'Outer Wall' || selectedBranch === 'Route Layer' ? null : (_jsx(SingleTool, { selected: activeTool === 'innerWall', children: _jsx(Tooltip, { title: "Inner Wall (W)", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => {
                                                                                if (selectedBranch === 'Route Layer' || selectedBranch === 'Outer Wall') {
                                                                                    message.warning('Please select a layer other than Route Layer or Outer Wall to draw or create a new layer');
                                                                                }
                                                                                else {
                                                                                    selectTool('innerWall');
                                                                                }
                                                                            }, icon: "Wall", size: 22 }) }) }) })), selectedBranch === 'Route Layer' ? (_jsx(SingleTool, { selected: activeTool === 'route', children: _jsx(Tooltip, { title: "Route", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => {
                                                                                selectTool('route');
                                                                                setSelectedBranch('Route Layer');
                                                                            }, icon: "edit-04", size: 22 }) }) }) })) : null, selectedBranch === 'Route Layer' || selectedBranch === 'Outer Wall' ? null : (_jsxs(SingleTool, { selected: ['rectangle', 'circle', 'custom'].includes(activeTool || ''), children: [_jsx(Tooltip, { title: (() => {
                                                                            switch (lastUsedShape) {
                                                                                case 'circle':
                                                                                    return 'Circle (V)';
                                                                                case 'custom':
                                                                                    return 'Custom (L)';
                                                                                default:
                                                                                    return 'Rectangle (V)';
                                                                            }
                                                                        })(), children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => {
                                                                                    if (selectedBranch === 'Route Layer' || selectedBranch === 'Outer Wall') {
                                                                                        message.warning('Please select a layer other than Route Layer or Outer Wall to draw or create a new layer');
                                                                                    }
                                                                                    else {
                                                                                        selectTool(lastUsedShape);
                                                                                    }
                                                                                }, icon: (() => {
                                                                                    switch (lastUsedShape) {
                                                                                        case 'circle':
                                                                                            return 'circle';
                                                                                        case 'custom':
                                                                                            return 'hexagon-02';
                                                                                        default:
                                                                                            return 'square'; // covers "rectangle" and default case
                                                                                    }
                                                                                })(), size: 22 }) }) }), _jsx(Tooltip, { title: "Shapes", children: _jsx(Dropdown, { trigger: ['click'], placement: "top", menu: { items: itemShapes }, children: _jsx(ToolDropDown, { children: _jsx(Icon, { icon: "chevron-down", size: 12 }) }) }) })] })), _jsx(SingleTool, { selected: activeTool === 'modify', children: _jsx(Tooltip, { title: "Modify", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => selectTool('modify'), icon: "pencil-01", size: 22 }) }) }) }), _jsx(SingleTool, { children: _jsx(Tooltip, { title: "Delete", children: _jsx(ToolIcon, { children: _jsx(Icon, { onClick: () => {
                                                                                deleteSelectedFeaturesLocal();
                                                                            }, icon: "trash-01", size: 22 }) }) }) })] }) }) }), _jsx(EditorMapController, { children: _jsx(EditorMapControllerInner, { children: _jsx(FloorDropdown, { trigger: ['click'], overlay: treeStructure, placement: "bottomRight", children: _jsxs("div", { children: [_jsx("span", { children: floorName }), _jsx(Icon, { icon: "chevron-selector-vertical", size: 18 })] }) }) }) }), _jsx(LeftPanel, { style: {
                                                    width: '240px',
                                                }, isOpen: selectedSidebar === 'mapping', children: _jsx(LeftPanelContainer, { children: _jsx(LeftPanelCard, { children: _jsxs(PanelBody, { children: [_jsx(PanelHeader, { children: _jsx(PanelHeaderTitle, { children: _jsx("span", { children: "Layers" }) }) }), _jsx(LayerManager, { hideLayer: (layerName) => {
                                                                        hideFeaturesLocal(layerName);
                                                                    }, unHideLayer: (layerName) => {
                                                                        unhideFeaturesLocal(layerName);
                                                                    }, setSelectedLayer: (value) => setSelectedBranch(value), layerData: branches, floorLayerData: floorLayerData, selectedLayer: selectedBranch || '', floorData: selectedKeys, createLayer: (value) => handleAddBranch(value) })] }) }) }) }), _jsx(LocationListPanel, { isOpen: selectedSidebar === 'locations' && editLocation === null, onBack: () => {
                                                    setEditLocation(null);
                                                    setSeletedSidebar('newLocation');
                                                }, onSelect: (data) => {
                                                    setEditLocation(data);
                                                } }), _jsx(FloorViewportListPanel, { isOpen: selectedSidebar === 'floor_viewport' && editFloorViewport === null, onBack: () => {
                                                    setEditFloorViewport(null);
                                                }, onSelect: (data) => {
                                                    setEditFloorViewport(data);
                                                } }), _jsx(ViewPortFormPanel, { isOpen: !!editFloorViewport, onBack: () => {
                                                    setEditFloorViewport(null);
                                                    setSeletedSidebar('floor_viewport');
                                                }, data: editFloorViewport, siteId: siteId, container: null }), _jsx(LanguageListPanel, { isOpen: selectedSidebar === 'languages', addLanguage: () => {
                                                    setSeletedSidebar('addLanguage');
                                                }, onSelect: (data) => {
                                                    setSeletedSidebar('languageConfig');
                                                    setLanguageConfigData(data);
                                                }, socket: socket }), _jsx(AddLanguageForm, { isOpen: selectedSidebar === 'addLanguage', onBack: () => {
                                                    setSeletedSidebar('languages');
                                                } }), _jsx(LanguageConfigForm, { isOpen: selectedSidebar === 'languageConfig', onBack: () => {
                                                    setSeletedSidebar('languages');
                                                }, data: languageConfigData, socket: socket }), _jsx(ThreeDObjectListPanel, { isOpen: selectedSidebar === '3dObject', onBack: () => {
                                                    setSeletedSidebar('new3dObject');
                                                } }), _jsx(ThreeDObjectFormPanel, { isOpen: selectedSidebar === 'new3dObject', onBack: () => {
                                                    setSeletedSidebar('3dObject');
                                                }, siteId: siteId, container: null }), _jsx(MappedThreeDObjectListPanel, { isOpen: selectedSidebar === 'mapped3dObjects' && editMappedThreedObject === null, onBack: () => {
                                                    setEditMappedThreedObject(null);
                                                    setSeletedSidebar('newMap3dObject');
                                                }, onSelect: (data) => {
                                                    setEditMappedThreedObject(data);
                                                } }), _jsx(MapThreeDObjectFormPanel, { isOpen: selectedSidebar === 'newMap3dObject' || !!editMappedThreedObject, onBack: () => {
                                                    setEditMappedThreedObject(null);
                                                    setSeletedSidebar('mapped3dObjects');
                                                }, data: editMappedThreedObject, siteId: siteId, activateSelectTool: updateStateData, mapObjectForm: mapObjectForm, container: null }), _jsx(LeftPanel, { style: {
                                                    width: '320px',
                                                }, isOpen: selectedSidebar === 'categories' && editCategory === null, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [selectedCat?.length > 0 ? (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx(AntdButton, { onClick: () => {
                                                                                    setSelectedCat([]);
                                                                                }, style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }) }), _jsx("h3", { children: selectedCat?.length }), _jsx(AntdButton, { color: "danger", variant: "text", icon: _jsx(Icon, { icon: "trash-01", size: 18 }) })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(Checkbox, { checked: selectedCat?.length === (locationCategories || []).length, onChange: (e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedCat((locationCategories || []).map((it) => it.categoryId));
                                                                                }
                                                                                else {
                                                                                    setSelectedCat([]);
                                                                                }
                                                                            }, children: "Select All" }) })] })) : (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "Categories" }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: () => {
                                                                                    setEditCategory(null);
                                                                                    formCategory.resetFields();
                                                                                    setSeletedSidebar('newCategory');
                                                                                } })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(PanelSearch, { placeholder: "Search Categories", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => {
                                                                                setSearchKey(e.target.value);
                                                                            } }) })] })), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { searchKey: searchKey, onCheckedItemsChange: (selectedItems) => {
                                                                        setSelectedCat(selectedItems);
                                                                    }, selectedItems: selectedCat, onSelect: (id) => {
                                                                        const find = locationCategories?.find((it) => it.categoryId === id);
                                                                        if (find) {
                                                                            let payload = { ...find };
                                                                            if (payload.color) {
                                                                                payload['color-origin'] = payload.color;
                                                                                payload['color'] = payload.color.hex;
                                                                            }
                                                                            if (payload.imageUrl) {
                                                                                payload['imageUrl'] = [
                                                                                    {
                                                                                        url: payload.imageUrl,
                                                                                        status: 'done',
                                                                                        uid: '-1',
                                                                                        name: 'initial-image.jpg',
                                                                                    },
                                                                                ];
                                                                            }
                                                                            //
                                                                            setEditCategory(payload);
                                                                            formCategory.setFieldsValue(payload);
                                                                        }
                                                                    }, data: (locationCategories || [])?.map((it) => ({
                                                                        name: it.name,
                                                                        id: it.categoryId,
                                                                    })) }) })] }) }) }), _jsx(LeftPanel, { style: {
                                                    width: '320px',
                                                }, isOpen: selectedSidebar === 'connections' && editConnections === null, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [selectedConnections?.length > 0 ? (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx(AntdButton, { onClick: () => {
                                                                                    setSelectedConnections([]);
                                                                                }, style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }) }), _jsx("h3", { children: selectedConnections?.length }), _jsx(AntdButton, { color: "danger", variant: "text", icon: _jsx(Icon, { icon: "trash-01", size: 18 }) })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(Checkbox, { checked: selectedConnections?.length === (connections || []).length, onChange: (e) => {
                                                                                if (e.target.checked) {
                                                                                    setSelectedConnections((connections || []).map((it) => it.connectionId));
                                                                                }
                                                                                else {
                                                                                    setSelectedConnections([]);
                                                                                }
                                                                            }, children: "Select All" }) })] })) : (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "Connections" }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: () => {
                                                                                    setEditConnection(null);
                                                                                    formCategory.resetFields();
                                                                                    setSeletedSidebar('newConnection');
                                                                                } })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(PanelSearch, { placeholder: "Search Connections", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => {
                                                                                setSearchKey(e.target.value);
                                                                            } }) })] })), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { searchKey: searchKey, onCheckedItemsChange: (selectedItems) => {
                                                                        setSelectedConnections(selectedItems);
                                                                    }, selectedItems: selectedConnections, onSelect: (id) => { }, data: (connections || [])?.map((it) => ({
                                                                        name: it?.name,
                                                                        id: it?.connectionId,
                                                                    })), onDelete: async (id) => {
                                                                        try {
                                                                            await _deleteConnection(siteId || '', id);
                                                                            await dispatch(getConnectionsAction(siteId || ''));
                                                                        }
                                                                        catch (error) {
                                                                            message.error('Something went wrong');
                                                                        }
                                                                    } }) })] }) }) }), _jsx(LocationPanel, { siteId: siteId, locationData: editLocation, onBack: onBackLocationPanel, isOpen: selectNode ? false : selectedSidebar === 'newLocation' || !!editLocation, selectNode: selctNodeLocationPanel, container: null, form: null }), _jsx(CategoryPanel, { siteId: siteId, categoryData: editCategory, onBack: onBackCategoryPanel, isOpen: isOpenCategoryPanel, container: null }), _jsx(EventPanel, { siteId: siteId, eventData: editEvent, onBack: onBackEventPanel, isOpen: isOpenEventPanel, container: null }), _jsx(EventListPanel, { onBack: () => {
                                                    setEditEvent(null);
                                                    setSeletedSidebar('newEvent');
                                                }, onSelect: (data) => {
                                                    setEditEvent(data);
                                                }, isOpen: selectedSidebar === 'events' && editEvent === null }), _jsx(ConnectionsPanel, { siteId: siteId, connectionData: editConnections, onBack: () => {
                                                    setSelectNode(false);
                                                    setSeletedSidebar('connections');
                                                    setEditConnection(null);
                                                }, isOpen: selectedSidebar === 'newConnection' || !!editConnections, form: formConnection, setSelectedNodeIndex: setSelectedNodeIndex, updateStateData: updateStateData, container: null }), _jsx(FloatingPanel, { isOpen: selectNode, placement: "center", position: "bottom", style: {
                                                    width: '340px',
                                                }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardBody, { style: { padding: '16px' }, children: _jsx("h4", { children: "Please select a node to attach to the location." }) }), _jsx(LeftPanelCardFooter, { children: _jsx(Button, { onClick: () => {
                                                                        setSelectNode(false);
                                                                        setActiveTool('select');
                                                                    }, variant: "solid", color: "primary", children: "Cancel" }) })] }) }) }), _jsx(ShapePropertiesPanel, { selectedItem: selectedFeatures, cancel: () => {
                                                    setSelectedFeatures(null);
                                                }, onChange: async (values) => {
                                                    onPropertiesChange(values, selectedFeatures, socket, () => {
                                                        setSelectedFeatures(null);
                                                    }, setRouteCollection, routeLayerRef, dispatch, siteId, selectedKeys);
                                                } })] }), _jsx(EditorMap, { ref: mapRef, tool: activeTool })] })] }) }) }), _jsx(Modal, { open: !socketIsConnected, closable: false, maskClosable: false, keyboard: false, footer: null, centered: true, children: _jsx("p", { children: socketMessage }) }), _jsx(ProgressModal, { open: routeFlag }), _jsx(BuildModal, { open: buildFlag })] }));
};
export default Editor;
